import { useState } from 'react';
import { AUSWERTUNG_PERIOD_PRESETS, resolvePeriod, todayIso, type AuswertungPeriodId, type ResolvedPeriod } from './period';

/** Globaler Zeitraumfilter des Auswertung-Hubs: Presets + freier Von/Bis-Zeitraum. */
export function PeriodFilter({ period, onChange }: {
  readonly period: ResolvedPeriod;
  readonly onChange: (period: ResolvedPeriod) => void;
}) {
  const [customFrom, setCustomFrom] = useState(period.id === 'custom' ? (period.from ?? '') : '');
  const [customTo, setCustomTo] = useState(period.id === 'custom' ? period.to : '');

  const applyCustom = (from: string, to: string) => {
    if (from && to && from <= to) onChange(resolvePeriod('custom', todayIso(), from, to));
  };

  return (
    <div className="auswertung-period" role="group" aria-label="Zeitraum">
      <div className="sales-controlling__periods">
        {AUSWERTUNG_PERIOD_PRESETS.map((preset) => (
          <button
            type="button"
            key={preset.id}
            className={period.id === preset.id ? 'is-active' : ''}
            onClick={() => onChange(resolvePeriod(preset.id as AuswertungPeriodId, todayIso()))}
          >
            {preset.label}
          </button>
        ))}
      </div>
      <div className="auswertung-period__custom">
        <label>von<input type="date" value={customFrom} max={customTo || undefined} onChange={(event) => { setCustomFrom(event.target.value); applyCustom(event.target.value, customTo); }} /></label>
        <label>bis<input type="date" value={customTo} min={customFrom || undefined} onChange={(event) => { setCustomTo(event.target.value); applyCustom(customFrom, event.target.value); }} /></label>
      </div>
    </div>
  );
}
